import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {ChangeOwnEmailAddressContent} from "./payloads/change-own-email-address-content";

/**
 * Action command (ADR-015/016): the logged-in user changes their own e-mail address (settings page
 * "Mein Profil"). `mainEntityClass` is `'user'`, `mainEntityUid` the user's own uid; the backend
 * refuses any other uid and needs the current password.
 *
 * No transformer (ADR-016): the payload is a `CommandPayload`, serialized by the generic path in
 * `TransformerHelper`.
 */
export class ChangeOwnEmailAddressCommand extends AbstractCommand<ChangeOwnEmailAddressContent> {

    public name: CommandName = CommandName.CHANGE_OWN_EMAIL_ADDRESS;

    public tags = ['own-profile', 'change'];

    constructor(userUid: string, content: ChangeOwnEmailAddressContent) {
        super('user', userUid, content);
    }
}
